import { Box } from '@chakra-ui/react';
import { FormControl } from 'components/ui';
import Select from 'react-select';
import { FORM_ACTIONS } from '../../utils/formActions.js';
import { locationOptions } from '../../data/locationOptions.js';

function SignUpInfoLocation({ dispatch, value }) {
  return (
    <Box minW={0} w="100%">
      <FormControl
        invalid={false}
        required
        data-testid={'signup-location-select'}
      >
        <FormControl.Label>Your primary state of residence</FormControl.Label>

        <Select
          accessibilityLabel="Choose Location"
          className={'sign-up-info-location'}
          components={{ IndicatorSeparator: () => null }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          onChange={(locationValue) => {
            dispatch({
              type: FORM_ACTIONS.UPDATE_FORM_FIELD,
              fieldName: 'state',
              payload: locationValue.value,
            });
          }}
          options={locationOptions}
          placeholder=""
          styles={{
            container: (base) => ({
              ...base,
              width: '100%',
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              width: '100%',
              borderRadius: '8px',
              height: 48,
              padding: '0px 8px',
              backgroundColor: 'rgba(4, 51, 56, 0.05)',
              borderColor: 'transparent',
              boxShadow: 'none',
            }),
          }}
          value={value}
        ></Select>
      </FormControl>
    </Box>
  );
}

export default SignUpInfoLocation;
